// lib/studio-list-versioning.ts
import type { WorkspaceVersion } from '#types/types';


export const shouldSkipListVersionPromotion = (
  _projectType: string | null | undefined,
  studioViewMode: string | null | undefined,
): boolean => studioViewMode === 'marketing';

export type ListVersionPromotionDecision = 'missing' | 'skip' | 'promote';

export const decideListVersionPromotion = (
  workspace: { projectId?: string | null } | null | undefined,
  versionToPromote: Pick<WorkspaceVersion, 'id'> | null | undefined,
  projectType: string | null | undefined,
  studioViewMode: string | null | undefined,
): ListVersionPromotionDecision => {
  if (!workspace || !versionToPromote) return 'missing';
  return shouldSkipListVersionPromotion(projectType, studioViewMode) ? 'skip' : 'promote';
};
